import { IncluirEstatistica } from './incluir/types';

export enum Types {
	ESTATISTICA_CLEAR = '@estatistica/ESTATISTICA_CLEAR',
}

export interface EstatisticaState {
	incluirEstatistica: IncluirEstatistica;
}
